import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-girl',
    templateUrl: './svg.girl.component.html',
    styleUrls: ['./svg.girl.component.scss'],
    standalone: false
})
export class SvgGirlComponent {
}
